import { lazy, Suspense, useEffect, useState } from 'react';

const DesktopLandingPage = lazy(() => import('./DesktopLandingPage'));
const MobileFigmaLanding = lazy(() => import('../components/MobileFigmaLanding'));

const getIsDesktop = () => (
  typeof window === 'undefined' || window.innerWidth >= 1024
);

const LandingPage = () => {
  const [isDesktop, setIsDesktop] = useState(getIsDesktop);

  useEffect(() => {
    const media = window.matchMedia('(min-width: 1024px)');
    const handleChange = (event) => setIsDesktop(event.matches);

    setIsDesktop(media.matches);
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, []);

  return (
    <Suspense
      fallback={(
        <div
          className="h-screen min-h-screen w-full bg-[#291E17]"
          aria-hidden="true"
        />
      )}
    >
      {isDesktop ? <DesktopLandingPage /> : <MobileFigmaLanding />}
    </Suspense>
  );
};

export default LandingPage;
